<template>
  <div class="booking-info-box">
    <div class="box">
      <dropdown-calendar-type-1
        v-model="tempDate"
        :prop-disable-days="serviceDetail.holidays"
        class="box-1"
      ></dropdown-calendar-type-1>
      <dropdown-time-type-3
        class="box-2"
        v-model="bookingTime"
      ></dropdown-time-type-3>
      <dropdown-box-type-1
        :mode="false"
        class="box-3"
        :class="{ 'page-active': currentMenu == 'mapSelect' }"
        boxTitle="Location"
        :data="bookingData"
        :index="1"
      ></dropdown-box-type-1>
      <dropdown-box-type-1
        :mode="false"
        class="box-4"
        :class="{ 'page-active': currentMenu == 'payment' }"
        boxTitle="PAYMENT"
        title="Check out"
      ></dropdown-box-type-1>
    </div>
  </div>
</template>
<script>
import DropdownCalendarType1 from '../common/DropdownCalendarType1'
import DropdownBoxType1 from '../common/DropdownBoxType1'
import * as types from '../../store/mutation-types'
import { mapGetters } from 'vuex'
import DropdownTimeType3 from '../common/DropdownTimeType3'

export default {
  components: {
    DropdownTimeType3,
    DropdownBoxType1,
    // DropdownTimeType1,
    DropdownCalendarType1
  },
  name: 'booking-info-box',
  data() {
    return {
      bookingData: {
        '1': {
          title: 'Meeting location',
          sort: 0
        }
      },
      tempDate: '',
      bookingTime: {}
    }
  },
  created() {
    console.log('searchForm:', this.searchForm)
    this.bookingTime = this.searchForm.time
  },
  watch: {
    tempDate(newVal) {
      this.$store
        .dispatch(types.SET_REQUEST_USER_BOOKING, { date: newVal })
        .then(() => {
          // console.log(this.searchForm)
        })
    },
    bookingTime(newVal, oldVal) {
      console.log('tempDate:', newVal)
      if (newVal === oldVal) return
      if (this.tempDate) {
        this.$store
          .dispatch(types.SET_REQUEST_USER_BOOKING, { reservation: newVal })
          .then(() => {
            // alert('Success edit')
            // console.log(this.searchForm)
          })
      } else {
        // alert('Before select date')
        // vm.bookingTime = {}
        // this.$store.dispatch(types.SET_MODAL_ALERT_FOOTER, {active: true, text: 'Choose date', propData: {}})
        //     .then(() => {
        //         setTimeout(() => {
        //             this.$store.commit(types.SET_MODAL_ALERT_FOOTER, {
        //                 active: false,
        //                 text: '',
        //                 propData: {}
        //             })
        //         }, 4000)
        //     })
      }
    }
  },
  computed: {
    ...mapGetters({
      searchForm: 'requestBookingInfo',
      currentMenu: 'modalRequestComponentName',
      serviceDetail: 'serviceDetail'
    })
  }
}
</script>

<style lang="scss" scoped>
.booking-info-box {
  display: flex;
  .box {
    height: 100px;
    /*border: 1px solid red;*/
    .box-1 {
    }

    .box-2 {
      margin-left: -1px;
    }

    .box-3 {
      margin-left: -1px;
    }

    .box-4 {
      margin-left: -1px;
    }

    .page-active {
      color: #ad08b8;
    }
  }
}
</style>
